<form [formGroup]="emailRequestFormGroup" #senderFormRef="ngForm" (ngSubmit)="sendEmailRequest()">
    <div class="modal-body">
        <div class="form-group position-relative row mx-auto">
            <label for="" class="col-3 label-control">Dirección de correo</label>
            <div class="col-9">
                <input type="email" name="email" class="form-control" formControlName="receiverEmail" autocomplete="off"
                    [ngClass]="{
                                'is-invalid': (senderFormRef.submitted && emailRequestFormGroup.controls['receiverEmail'].invalid ) || (emailRequestFormGroup.controls['receiverEmail'].touched && emailRequestFormGroup.controls['receiverEmail'].invalid)
                            }" />
                <div class="invalid-feedback"
                    *ngIf="senderFormRef.submitted && (emailRequestFormGroup.controls['receiverEmail'].invalid ||  emailRequestFormGroup.controls['receiverEmail'].touched ||  emailRequestFormGroup.controls['receiverEmail'].dirty)">
                    <div *ngIf="emailRequestFormGroup.get('receiverEmail').errors?.required">Campo Obligatorio</div>
                    <div *ngIf="emailRequestFormGroup.get('receiverEmail').hasError('toAddress')">Ingrese un email
                        válido</div>
                    <div *ngIf="emailRequestFormGroup.get('receiverEmail').errors?.maxlength">Ingrese menos de 320
                        carácteres</div>
                </div>
            </div>
        </div>
        <div class="form-group row mx-auto">
            <label for="ccEmail" class="col-3 label-control">CC</label>
            <div class="col-9">
                <input type="email" name="ccEmail" class="form-control" formControlName="ccEmail"
                    autocomplete="new-password" [ngClass]="{
                        'is-invalid': (senderFormRef.submitted && emailRequestFormGroup.controls['ccEmail'].invalid ) || (emailRequestFormGroup.controls['ccEmail'].touched && emailRequestFormGroup.controls['ccEmail'].invalid)
                    }" />
                <div class="invalid-feedback"
                    *ngIf="senderFormRef.submitted && (emailRequestFormGroup.controls['ccEmail'].invalid ||  emailRequestFormGroup.controls['ccEmail'].touched ||  emailRequestFormGroup.controls['ccEmail'].dirty)">
                    <div *ngIf="emailRequestFormGroup.get('ccEmail').errors?.required">Campo Obligatorio</div>
                    <div *ngIf="emailRequestFormGroup.get('ccEmail').hasError('toAddress')">Ingrese un email válido
                    </div>
                    <div *ngIf="emailRequestFormGroup.get('ccEmail').errors?.maxLength">Ingrese menos de 320 carácteres
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row mx-auto">
            <label for="ccoEmail" class="col-3 label-control">CCO</label>
            <div class="col-9">
                <input type="email" name="ccoEmail" class="form-control" formControlName="ccoEmail"
                    autocomplete="new-password" [ngClass]="{
                        'is-invalid': (senderFormRef.submitted && emailRequestFormGroup.controls['ccoEmail'].invalid ) || (emailRequestFormGroup.controls['ccoEmail'].touched && emailRequestFormGroup.controls['ccoEmail'].invalid)
                    }" />
                <div class="invalid-feedback"
                    *ngIf="senderFormRef.submitted && (emailRequestFormGroup.controls['ccoEmail'].invalid ||  emailRequestFormGroup.controls['ccoEmail'].touched ||  emailRequestFormGroup.controls['ccoEmail'].dirty)">
                    <div *ngIf="emailRequestFormGroup.get('ccoEmail').errors?.required">Campo Obligatorio</div>
                    <div *ngIf="emailRequestFormGroup.get('ccoEmail').hasError('toAddress')">Ingrese un email válido
                    </div>
                    <div *ngIf="emailRequestFormGroup.get('ccoEmail').errors?.maxLength">Ingrese menos de 320 carácteres
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">Enviar</span>
        </button>
        <button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>